var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cartItem"},[_c('i',{class:_vm.removeIcon,on:{"click":function($event){$event.preventDefault();return _vm.remove($event)}}}),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.item.qty)+" Stück(e): "+_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',{staticClass:"clear"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef9aaac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/templates/semperit/assets/js/modules/cart-small/components/CartSmallRow.vue
// module id = 7AUr
// module chunks = 4